<template>
        <div>
            <div class="c"></div>
            <div id="bd">
                <div class="" id="whous">
                    <img src="../assets/Images/zhfk_02.png">
                    <img src="../assets/Images/zhfk_03.png">  
                    <div class="tit-i" id="ydfx">
                        <h3>一道防线</h3>
                        <h5><span>DEFENSE </span>ONE</h5>
                    </div>
                    <div class="zh-linebox">
                        <div class="imgleft">
                            <img src="../assets/Images/zhfk_05.png">
                        </div>
                        <div class="zh-content ">
                            <h3>操作实名控制</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p style="width:70%">
                                通过部门逐级签到签退、生物识别登录及授权等机制保证系统登录身份真实，通过身份证识别办理业务确保客户身份真实。
                            </p>
                        </div>
                    </div>
                    <div class="zh-linebox bg-gray">
                        <div class="zh-content content-left" style="padding-top:140px;">
                            <h3>认证实名控制</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p>
                                基于统一的客户信息，通过人脸识别、银行U盾、短信验证码等认证手段确保互联网用户真实有效，确保资金交易安全。
                            </p>
                        </div>
                        <div class="imgright" style="float:right;">
                            <img  src="../assets/Images/zhfk_09.png">
                        </div>
                    </div>
                    <div class="zh-linebox" style="position:relative;padding-top:60px;overflow:hidden">
                        <div style="position: absolute;text-align:center;width:100%;">
                            <h3 style="margin:20px 0">业务办理控制</h3>
                            <p style="">
                                通过workflow、rule、电子档案等技术，实现业务流程控制、操作规则控制、操作权限控制及业务附件控制，确保业务受理安全。
                            </p>
                            <!-- <div style="text-align:center;" class="content-subtitle">通过workflow、rule、电子档案等技术，实现业务流程控制、操作规则控制、操作权限控制、业务附件控制，确保业务受理安全。</div> -->
                        </div>
                        <img src="../assets/Images/zhfk_11.png" style="width:100%;">
                    </div>
                    <div class="tit-i" id="edfx">
                        <h3>二道防线</h3>
                        <h5><span>DEFENSE </span>TWO</h5>
                    </div>
                    <div class="zh-linebox" style="position:relative;padding-top:60px;overflow:hidden">
                        <div style="position: absolute;text-align:center;width:100%;">
                            <h3 style="margin:20px 0">业务规则控制、业务流程控制、业务要件控制</h3>
                        </div>
                        <img src="../assets/Images/zhfk_13.png" style="width:100%;display:block">
                    </div>
                    <!-- <img src="../assets/Images/zhfk_13.png" style="display:block"> -->
                    <div class="zh-linebox">
                        <div class="imgleft">
                            <img src="../assets/Images/zhfk_14.png">
                        </div>
                        <div class="zh-content ">
                            <h3>交易安全控制</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p style="width:70%">
                                通过交易账户固化、账户每日核对、资金流量控制、业务资金阈值控制及账户额度预警等，实现对公积金资金交易的金融级安全保障。
                            </p>
                        </div>
                    </div>
                    <div class="zh-linebox bg-gray">
                        <div class="zh-content content-left" style="padding-top:140px;">
                            <h3>设备服务监控</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p>
                                通过对设备、中间件及网络运行情况的图形化实时监控，为信息部门提供运维保障，更好的避免信息安全事故发生。
                            </p>
                        </div>
                        <div class="imgright" style="float:right;">
                            <img  src="../assets/Images/zhfk_17.png">
                        </div>
                    </div>
                    <div class="tit-i" id="sdfx">
                        <h3>三道防线</h3>
                        <h5><span>DEFENSE </span>THREE</h5>
                    </div>
                    <div class="zh-linebox" >
                        <div class="wp">
                            <img src="../assets/Images/zhfk_20.png" style="width:100%;display:block">
                        </div>
                    </div>
                    <!--产品-->
                    <div class="wp">
                        <div class="tit-i">
                            <h3>产品</h3>
                            <h5><span>PRODUCTS</span></h5>
                        </div>
                        <ul class="product">
                            <li>稽核管理系统</li>
                            <li>行政执法系统</li>
                            <li>资产保全系统</li>
                            <li>人民银行征信直连</li>
                            <li>风险监控预警</li>
                            <li>审计管理</li>
                        </ul>
                    </div>
                    <div class="c h50"></div>
                     <div class="h50"></div>
                </div>
            </div>
            
        </div>
</template>
<script>
export default {
    mounted(){
        setTimeout(() => {
                // console.log($.isEmptyObject(this.$route.params))
                if(!$.isEmptyObject(this.$route.params)){
                    document.querySelector("#"+this.$route.params.id).scrollIntoView(true);  
                }
        }, 100);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/zhfk.vue